import Layers from "slotworks/graphics/layers/layers";
import { SceneTransition } from "slotworks/graphics/layers/scene-transitions/scene-transition";
import Contract from "slotworks/utils/contracts/contract";

export abstract class AbstractSceneTransition implements SceneTransition {

    protected layer: Layers;

    constructor(layer: Layers = null) {
        this.layer = layer;
    }

    public in() {
        return Contract.empty();
    }

    public out() {
        return Contract.empty();
    }

    public skipIn() {
        // Skip in
    }

    public skipOut() {
        // Skip out
    }

    public destroy() {
        // Destroy
    }
}
